import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Degrees extends OBase {
  update () {
    let valTree = this.getBoolInput('Update');
    let uOutput = this.getGenericObjectOutput('Unavailable List');
    let cOutput = this.getGenericObjectOutput('Can Use');

    var uOutTree = new Geometry.DataTree();
    var cOutTree = new Geometry.DataTree();

    uOutput.value = uOutTree;
    cOutput.value = cOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ValidateComponents.js